<div class="fgbcl-scorecard-hero-list" *ngIf="scorecards$ | async as scorecards">
  <!-- Mobile: horizontal scroll all panels (hidden on lg+) -->
  <div class="fgbcl-scorecard-mobile-scroll-wrap d-block d-lg-none">
    <div class="fgbcl-scorecard-mobile-panels d-flex">
      <div
        class="fgbcl-scorecard-hero-panel bg-glass d-flex align-items-center gap-3 cursor-pointer flex-shrink-0"
        *ngFor="let scorecard of scorecards"
        (click)="openDescription(scorecard)"
      >
        <div class="fgbcl-scorecard-panel-icon-wrapper flex-shrink-0">
          <img
            [src]="
              isStreakType(scorecard) ? ('placeholders/fireicon.svg' | contentAssetImage) : (scorecard.Image | contentImage: '6')
            "
            alt=""
            class="fgbcl-scorecard-panel-icon-img"
            [class.panel-icon-img-color]="isStreakType(scorecard) && scorecard.ActionsCompleted > 0"
          />
        </div>
        <ng-container *ngIf="isStreakType(scorecard); else nonStreakInfoMob">
          <div class="fgbcl-scorecard-panel-info d-flex flex-column gap-1 flex-grow-1 min-width-0">
            <p class="fgbcl-scorecard-panel-name mb-0">{{ scorecard.Name }}</p>
            <p class="fgbcl-scorecard-panel-streak-desc mb-0">{{ scorecard.ShortDescription }}</p>
          </div>
          <p class="fgbcl-scorecard-panel-streak-value mb-0 flex-shrink-0">{{ scorecard.ActionsCompleted }}</p>
        </ng-container>
        <ng-template #nonStreakInfoMob>
          <div class="fgbcl-scorecard-panel-info d-flex flex-column gap-1 flex-grow-1 min-width-0">
            <div
              class="fgbcl-scorecard-status-badge d-inline-flex align-items-center gap-1 align-self-start"
              [ngClass]="getStatusClass(scorecard)"
            >
              <span class="fgbcl-scorecard-badge-icon" [ngClass]="getStatusIconClass(scorecard)">{{ getStatusIcon(scorecard) }}</span>
              <span>{{ getStatusLabel(scorecard) | translate }}</span>
            </div>
            <p class="fgbcl-scorecard-panel-name mb-0">{{ scorecard.Name }}</p>
          </div>
          <p
            class="fgbcl-scorecard-panel-progress mb-0 flex-shrink-0"
            *ngIf="scorecard.ScoreCardDisplayType === ScorecardDisplayType.milestoneProgressBarView"
          >
            {{ scorecard.Milestone?.CustomerValue }}/{{ getMaxMilestone(scorecard) }}
          </p>
          <p class="fgbcl-scorecard-panel-progress mb-0 flex-shrink-0" *ngIf="isPercentageType(scorecard)">
            {{ getProgressPercentage(scorecard) }}%
          </p>
          <p class="fgbcl-scorecard-panel-progress mb-0 flex-shrink-0" *ngIf="isCounterType(scorecard)">
            {{ scorecard.ActionsCompleted }}
          </p>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Desktop: nav buttons + 2 panels (hidden on mobile) -->
  <div class="container spotlight-bar d-none d-lg-flex align-items-center gap-2">
    <button
      class="fgbcl-scorecard-nav-btn d-flex align-items-center justify-content-center flex-shrink-0 ps-0"
      [class.invisible]="!hasNav(scorecards.length)"
      [attr.aria-hidden]="!hasNav(scorecards.length) || null"
      [disabled]="!hasNav(scorecards.length)"
      (click)="prev(scorecards.length)"
    >
      <span class="material-icons">chevron_left</span>
    </button>

    <div class="fgbcl-scorecard-hero-panels d-flex gap-3 flex-grow-1 min-width-0" [class.fading]="isFading">
      <div
        class="fgbcl-scorecard-hero-panel bg-glass d-flex align-items-center gap-3 cursor-pointer"
        *ngFor="let scorecard of getVisibleScorecards(scorecards)"
        (click)="openDescription(scorecard)"
      >
        <div class="fgbcl-scorecard-panel-icon-wrapper flex-shrink-0">
          <img
            [src]="
              isStreakType(scorecard) ? ('placeholders/fireicon.svg' | contentAssetImage) : (scorecard.Image | contentImage: '6')
            "
            alt=""
            class="fgbcl-scorecard-panel-icon-img"
            [class.panel-icon-img-color]="isStreakType(scorecard) && scorecard.ActionsCompleted > 0"
          />
        </div>
        <ng-container *ngIf="isStreakType(scorecard); else nonStreakInfo">
          <div class="fgbcl-scorecard-panel-info d-flex flex-column gap-1 flex-grow-1 min-width-0">
            <p class="fgbcl-scorecard-panel-name mb-0">{{ scorecard.Name }}</p>
            <p class="fgbcl-scorecard-panel-streak-desc mb-0">{{ scorecard.ShortDescription }}</p>
          </div>
          <p class="fgbcl-scorecard-panel-streak-value mb-0 flex-shrink-0">{{ scorecard.ActionsCompleted }}</p>
        </ng-container>
        <ng-template #nonStreakInfo>
          <div class="fgbcl-scorecard-panel-info d-flex flex-column gap-1 flex-grow-1 min-width-0">
            <div
              class="fgbcl-scorecard-status-badge d-inline-flex align-items-center gap-1 align-self-start"
              [ngClass]="getStatusClass(scorecard)"
            >
              <span class="fgbcl-scorecard-badge-icon" [ngClass]="getStatusIconClass(scorecard)">{{ getStatusIcon(scorecard) }}</span>
              <span>{{ getStatusLabel(scorecard) | translate }}</span>
            </div>
            <p class="fgbcl-scorecard-panel-name mb-0">{{ scorecard.Name }}</p>
          </div>
          <p
            class="fgbcl-scorecard-panel-progress mb-0 flex-shrink-0"
            *ngIf="scorecard.ScoreCardDisplayType === ScorecardDisplayType.milestoneProgressBarView"
          >
            {{ scorecard.Milestone?.CustomerValue }}/{{ getMaxMilestone(scorecard) }}
          </p>
          <p class="fgbcl-scorecard-panel-progress mb-0 flex-shrink-0" *ngIf="isPercentageType(scorecard)">
            {{ getProgressPercentage(scorecard) }}%
          </p>
          <p class="fgbcl-scorecard-panel-progress mb-0 flex-shrink-0" *ngIf="isCounterType(scorecard)">
            {{ scorecard.ActionsCompleted }}
          </p>
        </ng-template>
      </div>
    </div>

    <button
      class="fgbcl-scorecard-nav-btn d-flex align-items-center justify-content-center flex-shrink-0 pe-0"
      [class.invisible]="!hasNav(scorecards.length)"
      [attr.aria-hidden]="!hasNav(scorecards.length) || null"
      [disabled]="!hasNav(scorecards.length)"
      (click)="next(scorecards.length)"
    >
      <span class="material-icons">chevron_right</span>
    </button>
  </div>
</div>
